import { render, staticRenderFns } from "./ChatBoxFlexCarousel.vue?vue&type=template&id=1272b4ed&scoped=true&"
import script from "./ChatBoxFlexCarousel.vue?vue&type=script&lang=js&"
export * from "./ChatBoxFlexCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxFlexCarousel.vue?vue&type=style&index=0&id=1272b4ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272b4ed",
  null
  
)

export default component.exports